import { useStoreContext } from "../index";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";

const Error = () => {
  const { userStore, keycloakStore } = useStoreContext();

  const errorMessage = userStore.error.has("user_403")
    ? "Access denied"
    : userStore.error.has("not_registererd")
    ? "Ditt personnummer är inte registrerat"
    : "Unknown error occured";

  return (
    <Box className="app-root-main">
      <Box component="main" className="main">
        <Box
          className="flex-column-center-center"
          sx={{
            width: "100%",
            alignSelf: "center",
            paddingTop: 10,
          }}
        >
          <Typography fontWeight="600" className="error-content">
            {errorMessage}
          </Typography>
          <Button sx={{ marginTop: 2 }} onClick={() => keycloakStore.logout()}>
            Logout
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Error;
